import { Pipe, PipeTransform } from "@angular/core";
import { Localizacao } from "src/app/models/address/localizacao.model";

@Pipe({
    name: 'address'
})
export class AddressFormatPipe implements PipeTransform {

    transform(value: Localizacao): string {
        return (`${value.logradouro}, ${value.numero} ${value.bairro ? ('- ' + value.bairro) : ''} ` +
            `${value.localidade} / ${value.uf}`)
    }
}